export const routes = (prefix = `finance-dashboard`) => [
    {
        path: `/${prefix}/voucher/print/:voucherNo`,
        name: `${prefix}.voucher.print`,
        component: () => import('./VoucherDetails.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.bill-payments.create`,
                PageDescription: "Finance: Bill Payment (Supplier and Consultants)",
            },
        },
    },
];
